import React from 'react'
import {
	Icon,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableRow,
} from '@mui/material'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import { applyMask } from '../../../../services/utils'
import { LoanCalculatorFormValues } from '../forms/LoanCalculatorForm'

export type LoanCalculatorResultsProps = {
	loanCalculatorData: LoanCalculatorFormValues
}
function LoanCalculatorResults({
	loanCalculatorData,
}: LoanCalculatorResultsProps) {
	if (!loanCalculatorData) {
		return null
	}
	return (
		<div>
			<div className="flex flex-row items-center mb-4">
				<p className="text-center text-xl font-rubik font-bold mr-2 dark:text-white w-full">
					Calculated Values
				</p>
				{loanCalculatorData.loanLocked && (
					<Icon className="h-5 w-6" aria-label="loan locked">
						<LockOutlinedIcon />
					</Icon>
				)}
			</div>
			<TableContainer className="md:max-w-[500px] mx-auto">
				<Table aria-label="simple table">
					<TableBody>
						<TableRow>
							<TableCell align="left">Monthly Payment</TableCell>
							<TableCell align="right">
								$
								{applyMask(
									loanCalculatorData.monthlyPayment,
									'fullCurrency'
								)}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell align="left">PITI</TableCell>
							<TableCell align="right">
								$
								{applyMask(
									loanCalculatorData.principleAndInterestPITIField,
									'fullCurrency'
								)}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell align="left">DTI Front</TableCell>
							<TableCell align="right">
								{loanCalculatorData.dtiFront}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell align="left">DTI Back</TableCell>
							<TableCell align="right">
								{loanCalculatorData.dtiBack}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell align="left">LTV</TableCell>
							<TableCell align="right">
								{loanCalculatorData.ltvFront}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell align="left">CLTV</TableCell>
							<TableCell align="right">
								{loanCalculatorData.ltvBack}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell align="left">Cash to Close</TableCell>
							<TableCell align="right">
								$
								{applyMask(
									loanCalculatorData.totalCashtoClose,
									'fullCurrency'
								)}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell align="left">APR</TableCell>
							<TableCell align="right">
								{loanCalculatorData.apr}
							</TableCell>
						</TableRow>
					</TableBody>
				</Table>
			</TableContainer>
		</div>
	)
}

export default LoanCalculatorResults
